import { useEffect, useState } from 'react'

/**
 * Track whether the window is currently in a mobile state based on the window width.
 *
 * @returns {boolean}  true  → window is in a mobile state
 */
export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768)

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [])

  return isMobile
}
